module.exports = __webpack_public_path__ + "static/media/floral-dress.ee1ddaee.jpg";